module.exports = {
	path: "/quotes",
	component: require("@views/Quotes").default,
	meta: {
		showButton: true,
		title: "Quotes",
		icon: ["far", "pencil-alt"],
		primary: true,
		// in_privacy: true,
		search: {
			placeholder: "Search Quotes",
			show: true
		}
	}
};
